export default __webpack_public_path__ + "static/media/consulting.cc459657.svg";